import React from 'react'
import { IIconProps } from '../types/types'

const AngryIcon: React.FC<IIconProps> = (props) => {
  return (
    <>
      <svg
        aria-hidden='true' focusable='false' data-prefix='fas' data-icon='angry'
        className='svg-inline--fa fa-angry fa-w-16' role='img' xmlns='http://www.w3.org/2000/svg'
        height={props.width ? props.width : '14px'}
        width={props.width ? props.width : '14px'}
        viewBox='0 0 496 512'
      >
        <path
          fill={props.color}
          d='M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z'
        />
      </svg>
    </>
  )
}

export default AngryIcon
